import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

const refactorMCData = (data) => {

  const heading = get(data, 'ibcHeading', null);
  const itemsArr = data.ibcItemsRep ? get(data, 'ibcItemsRep', []) : [];

  const items = itemsArr.map(item => {

    const img = item.ibcItemsImage ? refactorRespImg(item.ibcItemsImage, [{
      size: 'default',
      key: 'image_size_840x350'
    },{
      size: 'md',
      key: 'image_size_1280x650',
    },{
      size: 'lg',
      key: 'image_size_1600x800',
    }]) : null;

    return {
      bgImage: img,
      bgVideoMobile: {
        mimeType: get(item, 'ibcVideoMobile.mimeType', null),
        src: get(item, 'ibcVideoMobile.guid', null),
      },
      bgVideoDesktop: {
        mimeType: get(item, 'ibcVideoDesktop.mimeType', null),
        src: get(item, 'ibcVideoDesktop.guid', null),
      },
      video: get(item, 'ibcVideoUrl.url', null),
      content: {
        title: get(item, 'ibcTitle', null),
        text: get(item, 'ibcDescription', null),
        ctas: get(item, 'ibcCta', null) ? [item.ibcCta] : null,
      },
      alignContent: get(item, 'ibcTextPosition', 'left').toLowerCase()
    }
  })
  const forStart = '[{{#each data.banner.items~}}'
  const forEnd = '{{/each}}]'

  const handleBarItems = `
    ${forStart} {
      'bgVideoMobile': {
        'mimeType': '{{{ibcVideoMobile.mimeType}}}',
        'src': '{{{ibcVideoMobile.guid}}}'
      },
      'bgVideoDesktop': {
        'mimeType': '{{{ibcVideoDesktop.mimeType}}}',
        'src': '{{{ibcVideoDesktop.guid}}}'
      },
      'video': '{{{ibcVideoUrl.url}}}',
      'content': {
        'title': '{{{ibcTitle}}}',
        'text': '{{{ibcDescription}}}',
        'ctas': [{
          'title': '{{{cta.0.title}}}',
          'href': '{{{cta.0.href}}}'
        }]
      },
      'alignContent': '{{{ibcTextPosition}}}'
    }
    ${forEnd}
  `
  return {
    heading: heading,
    // items: !process.env.DEALER_SITE ? items : handleBarItems.toString().replace(/\n/g,'').replace(/'/g,'"').trim(),
    items

  }

  // Goal: 
  // items:[{
  //   bgVideoMobile: {
  //     mimeType: "video/mp4",
  //     src: 'https://ak.picdn.net/shutterstock/videos/1034064572/preview/stock-footage-california-united-states-july-th-aerial-view-yellow-vw-bus-van-on-a-parking-lot-on-a.mp4'
  //   },
  //   bgVideoDesktop: {
  //     mimeType: "video/mp4",
  //     src: 'https://ak.picdn.net/shutterstock/videos/1034064572/preview/stock-footage-california-united-states-july-th-aerial-view-yellow-vw-bus-van-on-a-parking-lot-on-a.mp4'
  //   },
  //   video: "https://www.youtube.com/watch?v=3rDjPLvOShM",
  //   heading:`Floor plan options 1`,
  //   content: {
  //     title:"Australia’s most recognised brand for RVs 1",
  //     text:"<p>Jayco is a great success story of Australian manufacturing. Employing over 1,000 Australians, Jayco continues as a locally owned family business. Built by Australians, for Australians to take on the Australian terrain letting you relax in the security of Jayco’s 43 years’ experience.</p>",
  //     cta: {
  //       title: "Start exploring",
  //       href: "#some-link"
  //     }
  //   }
  // }]
}

export default refactorMCData;